import {LoDashStatic} from "lodash";
import ILocationService = angular.ILocationService;
import {removeInvalids} from "../util/lodashExtensions.ts";
const _ = <LoDashStatic> require('lodash');

export interface UrlService {
    getParsedSearchParams(searchDefinition): {}
}

rkcApp.factory('urlService', ['$location', function ($location) {
    return {
        getParsedSearchParams:
            (searchDefinition)=> {
                var paramDefinitions = searchDefinition.fields;
                var urlParams = {};
                var queryParameters = $location.search();
                if (Object.keys(queryParameters).length !== 0) {
                    searchDefinition.activePredefinedSearch = null;
                    _.forEach(queryParameters, (queryParam, key)=> {
                        //If the url contains the name of a predefined search, its function should be run
                        if (!searchDefinition.activePredefinedSearch){
                            searchDefinition.activePredefinedSearch = _.find(searchDefinition.preDefinedSearches, {name: key});
                        }
                        var paramDef: any = _.find(paramDefinitions, {name:key});

                        if (queryParam !== null || queryParam === 0 || queryParam !== undefined) {
                            if(paramDef){
                                if (paramDef.type === 'number' ) {
                                    urlParams[key] = parseFloat(queryParam);
                                }
                                else if (paramDef.type === 'checkbox') {
                                    urlParams[key] = queryParam === "true" || queryParam;
                                }
                                else if (paramDef.type === 'select') {
                                    if (typeof queryParam === 'string'){
                                        urlParams[key] = [queryParam];
                                    } else {
                                        urlParams[key] = queryParam;
                                    }
                                }
                                else {
                                    urlParams[key] = queryParam;
                                }
                            }
                            else{
                                urlParams[key] = queryParam;
                            }
                        }
                    });
                    return removeInvalids(urlParams);
                }
                else {
                    return null;
                }
            }
    };
}]);



/** WEBPACK FOOTER **
 ** ./src/app/services/urlService.ts
 **/